import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class CountryCurrencyMapper {
  private currencyLocaleMap: Record<
    string,
    {
      currencyCode: string;
      // excelLocale is a hex value and can be found here: https://help.tradestation.com/10_00/eng/tsdevhelp/elobject/class_el/lcid_values.htm
      excelLocale: string;
    }
  > = {
    DE: { currencyCode: "EUR", excelLocale: "407" },
    AT: { currencyCode: "EUR", excelLocale: "C07" },
    CH: { currencyCode: "CHF", excelLocale: "807" },
    IN: { currencyCode: "INR", excelLocale: "4009" },
    AU: { currencyCode: "AUD", excelLocale: "C09" },
    FI: { currencyCode: "EUR", excelLocale: "040b" },
    DK: { currencyCode: "DKK", excelLocale: "406" },
    SE: { currencyCode: "SEK", excelLocale: "041d" },
    NO: { currencyCode: "NOK", excelLocale: "414" },
    BE: { currencyCode: "EUR", excelLocale: "813" },
    US: { currencyCode: "USD", excelLocale: "409" },
    FR: { currencyCode: "EUR", excelLocale: "040c" },
    MX: { currencyCode: "EUR", excelLocale: "080a" },
    MY: { currencyCode: "MYR", excelLocale: "4409" },
    BR: { currencyCode: "EUR", excelLocale: "416" },
    TEST: { currencyCode: "EUR", excelLocale: "407" },
  };

  getCurrency(countryCode: string): string {
    const normalizedCountryCode = countryCode.trim().toUpperCase();
    return this.currencyLocaleMap[normalizedCountryCode].currencyCode;
  }

  getExcelLocale(countryCode: string): string {
    const normalizedCountryCode = countryCode.trim().toUpperCase();
    return this.currencyLocaleMap[normalizedCountryCode].excelLocale;
  }
}
